/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalOnboardRequest
 */
export interface ExternalOnboardRequest {
    /**
     * User's email.
     * @type {string}
     * @memberof ExternalOnboardRequest
     */
    email: string;
    /**
     * Personal names of a user. Usually it is a first name
     * @type {string}
     * @memberof ExternalOnboardRequest
     */
    firstName: string;
    /**
     * Family names of a user. Usually it is a last name
     * @type {string}
     * @memberof ExternalOnboardRequest
     */
    lastName: string;
    /**
     * Name of user's organization
     * @type {string}
     * @memberof ExternalOnboardRequest
     */
    companyName: string;
    /**
     * Wallet data was returned from Keria. It is used to call keria boot
     * @type {string}
     * @memberof ExternalOnboardRequest
     */
    walletData: string;
    /**
     * Service provider for the specified organization
     * @type {string}
     * @memberof ExternalOnboardRequest
     */
    serviceProviderId?: string;
    /**
     * User can use external or internal wallet. Or user can be demo user and theirs wallet can be created by demo-tools
     * @type {string}
     * @memberof ExternalOnboardRequest
     */
    realm?: string;
    /**
     * URL of keria agent responsible for user's wallet
     * @type {string}
     * @memberof ExternalOnboardRequest
     */
    keriaAgentUrl?: string;
}

/**
 * Check if a given object implements the ExternalOnboardRequest interface.
 */
export function instanceOfExternalOnboardRequest(value: object): boolean {
    if (!('email' in value)) return false;
    if (!('firstName' in value)) return false;
    if (!('lastName' in value)) return false;
    if (!('companyName' in value)) return false;
    if (!('walletData' in value)) return false;
    return true;
}

export function ExternalOnboardRequestFromJSON(json: any): ExternalOnboardRequest {
    return ExternalOnboardRequestFromJSONTyped(json, false);
}

export function ExternalOnboardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalOnboardRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'companyName': json['companyName'],
        'walletData': json['walletData'],
        'serviceProviderId': json['serviceProviderId'] == null ? undefined : json['serviceProviderId'],
        'realm': json['realm'] == null ? undefined : json['realm'],
        'keriaAgentUrl': json['keriaAgentUrl'] == null ? undefined : json['keriaAgentUrl'],
    };
}

export function ExternalOnboardRequestToJSON(value?: ExternalOnboardRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'companyName': value['companyName'],
        'walletData': value['walletData'],
        'serviceProviderId': value['serviceProviderId'],
        'realm': value['realm'],
        'keriaAgentUrl': value['keriaAgentUrl'],
    };
}

